import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

interface BaseProps {
  label: string;
  hint?: string;
  id: string;
}

type InputProps = BaseProps & InputHTMLAttributes<HTMLInputElement> & { as?: 'input' };
type TextareaProps = BaseProps & TextareaHTMLAttributes<HTMLTextAreaElement> & { as: 'textarea' };
type SelectProps = BaseProps &
  SelectHTMLAttributes<HTMLSelectElement> & {
    as: 'select';
    children: React.ReactNode;
  };

type Props = InputProps | TextareaProps | SelectProps;

export function Field(props: Props) {
  const { label, hint, id } = props;

  let control: React.ReactNode;
  if (props.as === 'textarea') {
    const { as: _a, label: _l, hint: _h, id: _id, ...rest } = props;
    control = <textarea id={id} {...rest} />;
  } else if (props.as === 'select') {
    const { as: _a, label: _l, hint: _h, id: _id, children, ...rest } = props;
    control = (
      <select id={id} {...rest}>
        {children}
      </select>
    );
  } else {
    const { as: _a, label: _l, hint: _h, id: _id, ...rest } = props as InputProps;
    control = <input id={id} {...rest} />;
  }

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      {control}
      {hint && <div className="hint">{hint}</div>}
    </div>
  );
}
